'use strict';

module.exports = function(
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $window,
  $timeout,
  $location,
  customer,
  Customer,
  CustomerDA,
  AccountingDA,
  invoices,
  CustomerModel,
  DatepickerSettings,
  filteredCustomers,
  gettextCatalog,
  IndustrySpecific,
  ModalService,
  Notification,
  office,
  LocalStorage,
  resources,
  services,
  settings,
) {
  var isBillingVisible = require('t2g.common.isBillingVisible');

  $scope.resources = resources;
  $scope.currentCustomer = customer;
  $scope.filteredCustomers = filteredCustomers;
  $scope.translationData = {
    name: '',
  };
  $scope.filter = {};
  $scope.dtpOptions = DatepickerSettings.default;
  $scope.dtpOptionsFilterFrom = angular.copy(DatepickerSettings.default);
  $scope.dtpOptionsFilterTo = angular.copy(DatepickerSettings.default);
  $scope.smsReminderEnabled = _.get(office, 'settings.reminder.sms.enabled');
  $scope.emailReminderEnabled = _.get(office, 'settings.reminder.email.enabled');
  $scope.settings = settings;
  $scope.showBilling = isBillingVisible($location);
  var invoiceExportNow = new Date();
  var invoiceExportOptions = require('t2g.common.invoiceExportOptions')(gettextCatalog);

  $scope.invoiceExport = {
    month: null,
    year: invoiceExportNow.getFullYear(),
    billingType: invoiceExportOptions.defaultBillingType,
  };
  $scope.invoiceExportBillingTypes = invoiceExportOptions.billingTypes;
  $scope.invoiceExportMonths = [null, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  $scope.invoiceExportYears = [];

  for (
    var year = invoiceExportNow.getFullYear();
    year >= invoiceExportNow.getFullYear() - 10;
    year -= 1
  ) {
    $scope.invoiceExportYears.push(year);
  }

  $scope.getInvoiceDownloadLink = function() {
    if (!$scope.currentCustomer._id) {
      return '';
    }

    var link =
      '/api/office/' +
      office._id +
      '/export/rechnungen.csv?customer=' +
      $scope.currentCustomer._id +
      '&year=' +
      $scope.invoiceExport.year;

    if ($scope.invoiceExport.month) {
      link += '&month=' + $scope.invoiceExport.month;
    }

    link += '&billingType=' + $scope.invoiceExport.billingType;

    return link;
  };

  $scope.getInvoicePdfDownloadLink = function() {
    if (!$scope.currentCustomer._id) {
      return '';
    }

    var link =
      '/api/office/' +
      office._id +
      '/export/rechnungen.zip?customer=' +
      $scope.currentCustomer._id +
      '&year=' +
      $scope.invoiceExport.year;

    if ($scope.invoiceExport.month) {
      link += '&month=' + $scope.invoiceExport.month;
    }

    link += '&billingType=' + $scope.invoiceExport.billingType;

    return link;
  };
  $scope.invoiceFormSubmitted = false;
  $scope.CustomerInvoiceForm = {};
  $scope.invoices = invoices;
  $scope.treatmentTypes = [
    {
      value: gettextCatalog.getString('Individual Therapy'),
    },
    {
      value: gettextCatalog.getString('Group Therapy'),
    },
  ];
  $scope.treatmentBases = [
    {
      value: gettextCatalog.getString('Illness'),
    },
    {
      value: gettextCatalog.getString('Accident'),
    },
    {
      value: gettextCatalog.getString('Pregnancy'),
    },
    {
      value: gettextCatalog.getString('Prevention'),
    },
    {
      value: gettextCatalog.getString('Congenital Defects'),
    },
    {
      value: gettextCatalog.getString('Unknown'),
    },
  ];
  $scope.laws = [
    {
      value: 'UVG',
    },
    {
      value: 'VVG',
    },
  ];
  $scope.accidenTranslation = gettextCatalog.getString('Accident');

  function setMinMaxDate() {
    $scope.dtpOptionsFilterFrom.maxDate = $scope.filter.end;
    $scope.dtpOptionsFilterTo.minDate = $scope.filter.start;
  }

  $scope.$watch(
    'filter',
    function() {
      setMinMaxDate();
    },
    true,
  );

  if ($scope.currentCustomer && $scope.currentCustomer.birthday) {
    $scope.currentCustomer.birthday = new Date($scope.currentCustomer.birthday);
  }

  IndustrySpecific.getLabels().then(function(labels) {
    $scope.customerLabel = gettextCatalog.getString(labels.customer.toLowerCase());
    $scope.customersLabel = gettextCatalog.getString(labels.customers.toLowerCase());
  });

  var generateName = function() {
    var nameParts = [];

    if ($scope.currentCustomer.firstname) {
      nameParts.push($scope.currentCustomer.firstname);
    }

    if ($scope.currentCustomer.lastname) {
      nameParts.push($scope.currentCustomer.lastname);
    }

    $scope.translationData.name = nameParts.join(' ');
  };

  if ($scope.currentCustomer._id) {
    generateName();
  }

  $scope.$watch(
    'currentCustomer.firstname+currentCustomer.lastname',
    function() {
      generateName();
    },
    true,
  );

  /**
   * save current customer to database
   */
  $scope.save = function() {
    var name = $scope.currentCustomer.lastname + ', ' + $scope.currentCustomer.firstname;

    if ($scope.currentCustomer.email === '') {
      delete $scope.currentCustomer.email;
    }

    if ($scope.currentCustomer.birthday) {
      $scope.currentCustomer.birthday = moment($scope.currentCustomer.birthday)
        .hour(12)
        .toDate();
    }

    if (!$scope.currentCustomer._id) {
      CustomerDA.insert($scope.currentCustomer)
        .then(function(newCustomer) {
          Notification.addSuccessMessage(
            gettextCatalog.getString('{{name}} created', { name: name }),
          );

          $state.go(
            'private.main.customerProfile',
            {
              customerId: newCustomer._id,
            },
            { location: 'replace' },
          );
        })
        .catch(function(response) {
          Notification.addErrorMessage(
            gettextCatalog.getString('Cant add customer (Error: {{error}})', {
              error: response.error,
            }),
          );
        });
    } else {
      // update employee
      if (!$scope.isUnchanged()) {
        CustomerModel.update($scope.currentCustomer, function(error, response) {
          if (error) {
            Notification.addErrorMessage(
              gettextCatalog.getString('Cant update customer (Error: {{error}})', { error: error }),
            );
          } else {
            Notification.addSuccessMessage(
              gettextCatalog.getString('{{name}} updated', { name: name }),
            );

            $scope.currentCustomer = response;
            if (LocalStorage.get('openAppointment')) {
              $scope.backToReferrer();
            }
          }
        });
      } else {
        Notification.addSuccessMessage(
          gettextCatalog.getString('{{name}} updated', { name: name }),
        );
      }
    }
  };

  /**
   * go back to source (list|appointmentModal)
   */
  $scope.backToReferrer = function(upsertedCustomer) {
    var openAppointment = LocalStorage.get('openAppointment');

    if (openAppointment) {
      $state.go('private.main.calendar');

      switch (openAppointment.type) {
        case 'course':
          for (var i = 0, partLen = openAppointment.participants.length; i < partLen; i++) {
            if (openAppointment.participants[i] === '') {
              openAppointment.participants[i] = $scope.currentCustomer;
              break;
            }
          }

          ModalService.openAppointmentModal(openAppointment);
          break;
        case 'customer':
          var customerId = _.get(openAppointment, 'customer._id');
          var nameParts = [];

          if (!customerId && upsertedCustomer) {
            if (upsertedCustomer.lastname) {
              nameParts.push(upsertedCustomer.lastname);
            }

            if (upsertedCustomer.firstname) {
              nameParts.push(upsertedCustomer.firstname);
            }

            openAppointment.customer = {
              _id: upsertedCustomer._id,
              fullname: nameParts.join(' '),
            };
          }

          ModalService.openAppointmentModal(openAppointment);
          break;
      }
    } else {
      $state.go('private.main.customer');
    }
  };

  /**
   *  load the customer history
   */
  $scope.loadAppointments = function() {
    $scope.isLoading = true;

    if ($scope.currentCustomer._id) {
      CustomerDA.getAppointments($scope.currentCustomer._id, $scope.filter.start, $scope.filter.end)
        .then(function(appointments) {
          $scope.isLoading = false;
          $scope.appointments = appointments;
        })
        .catch(function(error) {
          $scope.isLoading = false;
          Notification.addErrorMessage(
            gettextCatalog.getString('Cant load appointments (Error: {{error}})', { error: error }),
          );
        });
    }
  };

  /**
   * delete a customer
   * @param customer
   */
  $scope.delete = function() {
    CustomerDA.remove($scope.currentCustomer._id)
      .then(function() {
        var name = $scope.currentCustomer.firstname + ' ' + $scope.currentCustomer.lastname;
        Notification.addSuccessMessage(
          gettextCatalog.getString('{{name}} updated', { name: name }),
        );
        $scope.backToReferrer();
      })
      .catch(function(error) {
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant delete customer (Error: {{error}})', { error: error }),
        );
      });
  };

  /**
   * open appointment modal
   * @param appointment
   */
  $scope.openAppointment = function(appointment) {
    appointment.start = new Date(appointment.start);
    appointment.end = new Date(appointment.end);

    ModalService.openAppointmentModal(appointment);
  };

  $scope.goToCustomer = function(direction) {
    var filteredCustomersLen = filteredCustomers.length;
    var currentIndex = filteredCustomers.indexOf($scope.currentCustomer._id);
    var targetIndex = currentIndex + direction;

    if (targetIndex < 0) {
      targetIndex = filteredCustomersLen - 1;
    } else if (targetIndex >= filteredCustomersLen) {
      targetIndex = 0;
    }

    if (filteredCustomers[targetIndex]) {
      $state.go('private.main.customerProfile', { customerId: filteredCustomers[targetIndex] });
    }
  };

  /**
   * check if form data is changed
   * @param customer
   * @returns {*}
   */
  $scope.isUnchanged = function() {
    return angular.equals($scope.currentCustomer, $scope.backupItem);
  };

  $scope.print = function() {
    $window.print();
  };

  // invoice
  $scope.services = angular.copy(services);
  $scope.currentInvoice = null;
  $scope.currentService = {
    selected: null,
  };
  $scope.netTotal = 0;
  $scope.taxTotal = 0;
  $scope.grossTotal = 0;
  $scope.taxes = [
    {
      label: '0.0 %',
      value: 0,
    },
    {
      label: '2.5 %',
      value: 2.5,
    },
    {
      label: '7.7 %',
      value: 7.7,
    },
    {
      label: '8.1 %',
      value: 8.1,
    },
  ];

  // add free text position
  $scope.services.push({
    name: '[Tarif 999] Freitext',
    tax: 8.1,
    accounting: {
      posNum: '999',
      description: 'free',
    },
    price: 0,
  });

  $scope.currentServiceChanged = function() {
    var name;
    var customName;
    var amount;
    var tariffDuration;
    var tax;
    var num;
    var price;

    if ($scope.currentService.selected) {
      name = _.get(
        $scope.currentService.selected,
        'accounting.posText',
        $scope.currentService.selected.name,
      );
      customName = $scope.currentService.selected.name;
      tariffDuration = _.get($scope.currentService.selected, 'accounting.tariffDuration');
      tax = _.get($scope.currentService.selected, 'accounting.tax', 8);
      num = _.get($scope.currentService.selected, 'accounting.posNum');

      if (tariffDuration) {
        amount = $scope.currentService.selected.duration / tariffDuration;
        price = $scope.currentService.selected.price / amount;
      } else {
        amount = 1;
        price = $scope.currentService.selected.price;
      }

      if (num === '999') {
        if (!price) {
          name = '';
        } else {
          name = $scope.currentService.selected.name;
        }
      }

      var selectedService = {
        _id: $scope.currentService.selected._id,
        date: new Date(),
        name: name,
        customName: customName,
        price: price,
        amount: amount,
        total: amount * price,
        tax: tax,
        num: num,
      };

      if (parseInt(num) >= 1250) {
        selectedService.name = $scope.currentService.selected.name;
        selectedService.description = name;
      }

      $scope.currentInvoice.services.push(selectedService);
      $scope.currentService.selected = null;
    }
  };

  $scope.switchToInvoice = function() {
    $scope.currentInvoice = {
      services: [],
      defaultNo:
        'R' +
        '-' +
        moment().format('YYYYMMDD') +
        '****** (' +
        gettextCatalog.getString('Default') +
        ')',
      customNo: '',
      meta: {
        therapyType: gettextCatalog.getString('Individual Therapy'),
        treatmentBase: gettextCatalog.getString('Illness'),
        law: 'VVG',
      },
    };
  };

  $scope.editInvoice = function(invoice) {
    $scope.currentInvoice = invoice;

    if ($scope.currentInvoice.positions) {
      $scope.currentInvoice.services = $scope.currentInvoice.positions.map(function(item) {
        item.date = new Date(item.date);

        return item;
      });
    }

    $scope.currentInvoice.customNo = $scope.currentInvoice.no || '';
    $scope.currentInvoice.defaultNo =
      'R' + '-' + moment($scope.currentInvoice.created).format('YYYYMMDDHHmmss');
  };

  $scope.removeService = function(index) {
    $scope.currentInvoice.services.splice(index, 1);
  };

  $scope.changeQuantity = function(service, amount) {
    service.amount = service.amount + amount;
    service.amount = Math.max(service.amount, 1);

    if (service.price) {
      service.total = service.price * service.amount;
    }
  };

  $scope.abortInvoice = function() {
    $scope.currentInvoice = null;
  };

  $scope.removeInvoice = function(invoice) {
    AccountingDA.removeInvoice(invoice._id)
      .then(function() {
        Notification.addSuccessMessage(gettextCatalog.getString('Invoice deleted'));
        _.remove($scope.invoices, { _id: invoice._id });
      })
      .catch(function(error) {
        Notification.addErrorMessage(
          gettextCatalog.getString('Cant delete invoice (Error: {{error}})', { error: error }),
        );
      });
  };

  $scope.createInvoice = function() {
    var invoice = {
      customer: $scope.currentCustomer._id,
      office: office._id,
      customNo: $scope.currentInvoice.customNo,
      meta: $scope.currentInvoice.meta,
      comment: $scope.currentInvoice.comment,
      deposit: $scope.currentInvoice.deposit,
      positions: [],
    };

    $scope.invoiceFormSubmitted = true;

    if ($scope.CustomerInvoiceForm.instance.$valid) {
      _.forEach($scope.currentInvoice.services, function(service) {
        var position = {
          amount: service.amount,
          name: service.name,
          customName: service.customName,
          date: service.date,
          price: service.price,
          tax: service.tax,
        };

        if (service.num) {
          position.data = {
            num: service.num,
            description: service.description,
          };
        }

        invoice.positions.push(position);
      });

      AccountingDA.createInvoice(invoice)
        .then(function(response) {
          $scope.currentInvoice = null;
          $scope.invoices.unshift(response.invoice);
        })
        .catch(function(error) {
          console.log('error');
          console.log(error);
        });
    }
  };

  $scope.updateInvoice = function() {
    var invoice = {
      customer: $scope.currentCustomer._id,
      office: office._id,
      customNo: $scope.currentInvoice.customNo || $scope.currentInvoice.defaultNo,
      meta: $scope.currentInvoice.meta,
      comment: $scope.currentInvoice.comment,
      deposit: $scope.currentInvoice.deposit,
      positions: [],
    };

    $scope.invoiceFormSubmitted = true;

    if ($scope.CustomerInvoiceForm.instance.$valid) {
      _.forEach($scope.currentInvoice.services, function(service) {
        var position = {
          amount: service.amount,
          name: service.name,
          customName: service.customName,
          date: service.date,
          price: service.price,
          tax: service.tax,
        };

        if (service.data) {
          position.data = service.data;
        }

        if (service.num) {
          position.data = {
            num: service.num,
            description: service.description,
          };
        }

        invoice.positions.push(position);
      });

      AccountingDA.updateInvoice($scope.currentInvoice.id, invoice)
        .then(function(response) {
          $scope.currentInvoice = null;
          Notification.addSuccessMessage(gettextCatalog.getString('Invoice updated'));

          var invoiceIndex = $scope.invoices.reduce(function(previous, current, index) {
            return current.id === response.invoice.id ? index : previous;
          }, -1);

          if (invoiceIndex !== -1) {
            $scope.invoices.splice(invoiceIndex, 1, response.invoice);
          }
        })
        .catch(function(error) {
          Notification.addErrorMessage(
            gettextCatalog.getString('Cant update invoice (Error: {{error}})', { error: error }),
          );
        });
    }
  };

  $scope.$watch(
    'currentInvoice.services',
    function() {
      calcTotal();
    },
    true,
  );

  function calcTotal() {
    $scope.netTotal = 0;
    $scope.taxTotal = 0;
    $scope.grossTotal = 0;

    if ($scope.currentInvoice) {
      _.forEach($scope.currentInvoice.services, function(service) {
        service.total = service.price && service.amount ? service.price * service.amount : 0;
        $scope.netTotal += (service.total * 100) / (100 + service.tax);
        $scope.grossTotal += service.total;
      });
    }

    $scope.taxTotal = $scope.grossTotal - $scope.netTotal;
  }

  $scope.loadAppointments();
};



// WEBPACK FOOTER //
// ./src/app/modules/customer/profile/CustomerProfileCtrl.js